import { render, staticRenderFns } from "./ResellersEditModal.vue?vue&type=template&id=3f039205&scoped=true"
import script from "./ResellersEditModal.vue?vue&type=script&lang=js"
export * from "./ResellersEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f039205",
  null
  
)

export default component.exports